import { Controller } from '@hotwired/stimulus'

const HIDDEN_PWD_ICON = 'fa-eye-slash';
const VISIBLE_PWD_ICON = 'fa-eye';

export default class PasswordInputController extends Controller {
  static targets = ['pwdInput', 'toggleVisibilityBtn', 'visibilityIcon'];
  passwordVisible = false;


  toggleVisibility() {
    this.passwordVisible = !this.passwordVisible;

    if (this.passwordVisible) {
      this.pwdInputTarget.type = 'text';
      this.visibilityIconTarget.classList.remove(HIDDEN_PWD_ICON);
      this.visibilityIconTarget.classList.add(VISIBLE_PWD_ICON);
    } else {
      this.pwdInputTarget.type = 'password';
      this.visibilityIconTarget.classList.add(HIDDEN_PWD_ICON);
      this.visibilityIconTarget.classList.remove(VISIBLE_PWD_ICON);
    }
  }
}
